import { render, staticRenderFns } from "./DialogViewGroupUser.vue?vue&type=template&id=284d25ab&scoped=true"
import script from "./DialogViewGroupUser.vue?vue&type=script&lang=js"
export * from "./DialogViewGroupUser.vue?vue&type=script&lang=js"
import style0 from "./DialogViewGroupUser.vue?vue&type=style&index=0&id=284d25ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d25ab",
  null
  
)

export default component.exports